export default {
    createPassword: 'Create a new password',
    newPasswordLabel: 'New password',
    newPasswordPlaceholder: 'Password',
    confirmPasswordLabel: 'Confirm password',
    confirmPasswordPlaceholder: 'Confirm password',
    resetPasswordButton: 'Reset password',
    resettingPassword: 'Resetting password',

    passwordsNotMatching: 'Passwords do not match.',
};
